

import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { colors, LinearProgress, withStyles, createStyles, Theme } from '@material-ui/core';
import CustomProgressBar from 'components/Progress/CustomProgressBar';

interface Props{
  label: string;
  value: number;
  color: string;
  style?: React.CSSProperties;
}


const useStyles = makeStyles((theme: Theme) => 
createStyles({
  colorPrimary: {
    backgroundColor: theme.palette.grey[800],
  },
  bar: {
    backgroundColor: (props: any)=>{
      return props.color
    }
  }
}));

export const GameProgressBar: React.FC<Props> = (props) => {
  const classes = useStyles(props);


  return (
    <React.Fragment>
      {/*@ts-ignore*/}
      <CustomProgressBar classes={classes} style={props.style ? props.style : {height:'1.5em'}} customLabel={props.label} variant="determinate" value={props.value} />
    </React.Fragment>
  )
}

/*
*/